import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'

import { BASE_URL } from '@/shared/lib/const/env'
import { useMedia } from '@/shared/lib/hooks/useMedia'
import { Image } from '@/shared/ui/Image'

import cl from './NotificationMessage.module.scss'

interface NotificationMessageProps {
	className?: string
	text: string
	imageSrc: string
	link: string
	buttonText: string
	mobileText: string
	mobileButtonText: string
}

export const NotificationMessage = (props: NotificationMessageProps) => {
	const { className, text, imageSrc, link, buttonText, mobileText, mobileButtonText } = props
	const { isLargerThan } = useMedia()
	const isMobile = !isLargerThan(`768px`)

	const title = isMobile ? mobileText : text
	const button = isMobile ? mobileButtonText : buttonText

	const classes = clsx(cl.notificationMessage, className)
	return (
		<aside className={classes}>
			{!isMobile && (
				<Image
					alt={text}
					src={BASE_URL + imageSrc}
					width={40}
					height={40}
					title={text}
					style={{ objectFit: 'contain' }}
					priority
					quality={100}
					className={cl.NotificationMessage__image}
				/>
			)}
			<p className={cl.NotificationMessage__text}>{title}</p>
			<Link prefetch={false} className={cl.NotificationMessage__button} href={link}>
				{button}
			</Link>
		</aside>
	)
}
